import { Alert, Snackbar } from "@mui/material";
import { useSnackbar } from "./SnackbarContext";
import "./SnackbarComponent.css";
import { emptyToastMessage } from "consts/common";

const SnackbarComponent = ({
  duration,
  labelMessage,
  labelTitle,
  type,
  onClose
}) => {
  const { message, setMessage } = useSnackbar();

  const close = () => {
    setMessage(emptyToastMessage);
    onClose && onClose()
  };

  const isOpen = Boolean(message.title || message.desc || labelMessage || labelTitle);

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      autoHideDuration={duration}
      className='snackbar'
      open={isOpen}
      onClose={close}
    >
      <Alert severity={type}>
        <div className='snackbar-content'>
          {labelTitle && <p className='snackbar-title'>{labelTitle}</p>}

          <p className='snackbar-message'>{labelMessage}</p>
        </div>
      </Alert>
    </Snackbar>
  );
};

export default SnackbarComponent;
